<template>
    <div class="container pr-3 pl-3 margin-5" style="background-color: white">
        <div class=" pr-3 pl-3" style="margin-top: 5%">
            <div class=" col-12 logo-side text-center">
                <img class="mt-md-3 logo-size"
                     src="../assets/logo-login.png">
                &nbsp;
                <span class="text-head">กองโรคไม่ติดต่อ</span>
            </div>
        </div>
        <div class="mt-3 offset-sm-2 col-sm-8 offset-1 col-10">
            <div class="text-content text-center">
                <div class="pl-5 pr-5 ">
                        เลขที่ 88/21 อาคาร 10 ชั้น 5 ตึกกรมควบคุมโรค
                    ถนนติวานนท์ ตำบลตลาดขวัญ อำเภอเมือง จังหวัดนนทบุรี 11000
                </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                            โทรศัพท์
                        </div>
                        <div>0 2590 3888, 0 2590 3889</div>
                    </div>
                </div>

            </div>
            <div class="text-center mt-2">
                <b-button href="/login" variant="dark"
                          class=" btn-form ">
                <span >
                    กลับสู้หน้า ล็อคอิน
                </span>
                </b-button>
            </div>


        </div>

        <!--        <pre class="alert-danger">{{form}}</pre>-->
        <!--        <pre v-if="form.province" class="alert-danger">{{form.province.code}}</pre>-->
    </div>
</template>

<script>
    export default {
        name: "ContactView.vue"
    }
</script>

<style scoped>
    .logo-size{
        height: 100px;
    }
    .text-head{
        font-size: 35px;
        font-weight: 700;
        color: #006738;
    }

    .text-content{
        font-size: 18px;
        font-weight: 700;
        color: #006738;
    }
    .btn-form{
        background-color: #006738;
        color: white;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        border: 0;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 2px;
        text-align: center;
    }

    @media only screen and (max-width: 767px) {
        .logo-size{
            height: 60px;
        }
        .text-head{
            font-size: 20px;

        }
    }

    @media only screen and (max-width: 499px) {
        .logo-size{
            height: 50px;
        }
        .text-head{
            font-size: 18px;
        }
        .btn-form{
            font-size: 16px;
        }
        .text-content{
            font-size: 16px;
        }
    }

</style>